export default "__VITE_ASSET__lTlPt_pK__"